import React, { Component } from 'react';
import { Link } from '@zocdoc-frontend-common/components-link';

export class ErrorModalDescription extends Component {
    render() {
        return (
            <div data-test="error-modal-description">
                Please try booking again. If this error persists, contact us at{' '}
                <Link href="mailto:service@zocdoc.com">service@zocdoc.com</Link>
                {' or call '}
                <Link href="tel:866-962-3621">866-962-3621</Link>
            </div>
        );
    }
}
